import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES, CONTACT_EMAIL } from "../../../../helpers/constants";
import { featureToggles } from "../../../../utils/featureToggles";
import ClientPlansModal from "./client-plans-modal";

const FolderContentComponent = ({ client }) => {
  const navigate = useNavigate();
  const [isPlansOpen, setIsPlansOpen] = useState(false);
  const togglePlans = () => setIsPlansOpen((prev) => !prev);

  return (
    <div className="gm-folder-content-container gm-col--3">
      <div className="gm-folder-section">
        <div className="gm-info-group">
          <div className="gm-folder-label">Nombre Empresa</div>
          <div className="gm-folder-info">{client?.name}</div>
        </div>
        <div className="gm-info-group">
          <div className="gm-folder-label">Rut Empresa</div>
          <div className="gm-folder-info">{client.rut}</div>
        </div>
        <div className="gm-info-group">
          <div className="gm-folder-label">Rubro</div>
          <div className="gm-folder-info">{client?.sector || "No Informada"}</div>
        </div>
      </div>
      <div className="gm-folder-section">
        <div className="gm-info-group">
          <div className="gm-folder-label">Responsable</div>
          <div className="gm-folder-info">{client.responsibleName}</div>
        </div>
        <div className="gm-info-group">
          <div className="gm-folder-label">Cargo</div>
          <div className="gm-folder-info">{client.responsiblePosition}</div>
        </div>
        <div className="gm-info-group">
          <div className="gm-folder-label">Correo</div>
          <div className="gm-folder-info">{client.responsibleEmail}</div>
        </div>
        <div className="gm-info-group">
          <div className="gm-folder-label">Teléfono</div>
          <div className="gm-folder-info">{client.responsiblePhoneNumber}</div>
        </div>
      </div>
      <div className="gm-folder-section">

        { /* hiding sections for now */
         false &&  <>
        <div className="gm-info-group">
          <div className="gm-folder-label">Servicio Contratado</div>
          <div className="gm-folder-info">
            {client.internalSelection ? "Plan Desarrollo de Carrera" : ""}
          </div>
          <div className="gm-folder-info">
            {client.externalSelection ? "Plan Selección Externa" : ""}
          </div>
        </div>
        <div className="gm-info-group">
          <div className="gm-folder-label">Prueba Disponible</div>
          {client.assignedTest?.map((test, index) => (
            <div key={`${test}-${index}`} className="gm-folder-info">{test}</div>
          ))}
        </div>
        </>
        }
        <div className="gm-folder-stadistic-section">
          <div className="gm-info-group">
            <div className="gm-folder-label">Pruebas Enviadas</div>
            <div className="gm-number-info">{client.testsDone || 0}</div>
          </div>
          <div className="gm-info-group">
            <div className="gm-folder-label">Pruebas Disponibles</div>
            <div className="gm-number-info">{client.testsAvailable || 0}</div>
          </div>
        </div>
        <div className="gm-folder-stadistic-section gm-folder-buttons-group">
          { featureToggles.isEnabled('enablePurchaseSection') &&
          <button
            type="button"
            className="gm-primary-button"
            onClick={() => navigate(ROUTES.PURCHASE.route, { state: { client } })}
          >
            Necesito más tests
          </button>
          }
          { featureToggles.isEnabled('enableClientsPlans') &&
          <button
            type="button"
            className="gm-outline-button"
            onClick={togglePlans}
          >
            Mis planes
          </button>
          }
          { !featureToggles.isEnabled('enablePurchaseSection') &&
            <p>
          ¿Necesitas más test? Escríbenos a <span>{CONTACT_EMAIL}</span>
          </p>
          }
        </div>
        { featureToggles.isEnabled('enableClientsPlans') &&
          <ClientPlansModal
            open={isPlansOpen}
            toggle={togglePlans}
            clientId={client?.id}
          />
        }
      </div>
    </div>
  );
};

export default FolderContentComponent;